import { useEffect, useState } from "react";
import {
  OrderStatus,
  PricelistOffersGetByIdOffers,
  PricelistOffersGetByIdPayload,
} from "../../../../services/orders/pricelist-offers-get-by-id/types";
import { StyledTable } from "../../../../components/table/styled-table";
import { GridColDef } from "@mui/x-data-grid";
import { theme } from "../../../../helpers/theme";

import {
  dateFormating,
  getMagazineTypeFromEnum,
  getStatusOfOfferEnum,
  priceFormating,
} from "../helpers";
import styled from "styled-components";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteOffer } from "../../../../services/offers/delete-offer";
import { LoadingBackDrop } from "../../../../components/loader";
import { StyledDialog } from "../../../../components/dialog/dialog";
import { toast } from "react-toastify";
import { settings } from "../../../../helpers/toast.settings";
import { useNavigate } from "react-router-dom";
import { showPotentialWarehouses } from "../../../../services/offers/show-potential-warehouses";
import { Button } from "@mui/material";

interface OfferingOfferDetailsTableProps {
  pricelistOffer: PricelistOffersGetByIdOffers;
  isDeletable: boolean;
}
const OfferingOfferDetailsTable = ({
  pricelistOffer,
  isDeletable,
}: OfferingOfferDetailsTableProps) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [openOfferDialog, setOpenOfferDialog] = useState(false);
  const [offerId, setOfferId] = useState("");
  const deleteOfferMutation = useMutation(deleteOffer, {
    onSuccess: () => {
      queryClient.invalidateQueries(["OrdersPricelistOffers"]);
    },
  });

  const { data }: any = queryClient.getQueryState([
    "OrdersPricelistOffers",
  ])?.data;

  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 450,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <ButtonsWrapper>
          <Button
            variant="contained"
            style={{
              backgroundColor: "orange",
            }}
            onClick={() => {
              return navigate(
                `/operator/orders/offering/offer-edit/${params.id}`
              );
            }}
          >
            Edytuj
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "red",
            }}
            onClick={() => {
              setOfferId(params.row.id);
              if (
                data.payload.status_zamowienia ===
                  OrderStatus.W_trakcie_realizacji ||
                data.payload.status_zamowienia === OrderStatus.Zrealizowano ||
                !isDeletable
              ) {
                toast.error("Nie możesz usuwać zatwierdzonej oferty", {
                  toastId: "Cannot delete position",
                  ...settings,
                });
              } else setOpenOfferDialog(true);
            }}
          >
            Usuń
          </Button>
          <StyledDialog
            open={openOfferDialog}
            setOpen={setOpenOfferDialog}
            confirmFunction={() =>
              deleteOfferMutation.mutate({
                id_oferty: offerId,
              })
            }
            dialogContent="Czy na pewno chcesz usunąć ofertę?"
          />
          <Button
            variant="contained"
            style={{
              backgroundColor: theme.colors.blue01_active,
            }}
            onClick={() =>
              navigate(
                `/operator/orders/offering/potential-warehouses/${pricelistOffer.id_oferta}`
              )
            }
          >
            Dodaj ofertę Podwykonawcy
          </Button>
        </ButtonsWrapper>
      ),
    },

    { field: "data_utworzenia", headerName: "Data utworzenia", width: 200 },
    { field: "data_ważności", headerName: "Data ważności", width: 200 },
    { field: "status", headerName: "Status", width: 150 },
    { field: "rodzaj", headerName: "Rodzaj", width: 200 },
    {
      field: "notatka_konsultanta",
      headerName: "Notatka konsultanta",
      width: 500,
    },
    {
      field: "koszt_lacznie",
      headerName: "Koszt łącznie",
      width: 200,
    },
  ];
  const summaryPrice = pricelistOffer.oferty_podwykonawcy
    .map((item) =>
      item.pozycje_oferty.reduce(
        (accumulator, currentValue) => accumulator + (currentValue.cena_docelowa?currentValue.cena_docelowa:0),
        0
      )
    )
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  const rows = [pricelistOffer].map((r) => ({
    id: r.id_oferta,
    data_utworzenia: dateFormating(r.data_wprowadzenia),
    data_ważności: "-",
    status: getStatusOfOfferEnum(r.status_oferty),
    rodzaj: getMagazineTypeFromEnum(r.rodzaj_oferty),
    notatka_konsultanta: r.notatka_konsultanta,
    koszt_lacznie: priceFormating(summaryPrice),
  }));

  return (
    <StyledTable
      getRowId={(row:any) => row?.id}
      rows={rows}
      columns={columns}
      hideFooter={true}
      pageSize={1}
      disableSelectionOnClick={true}
      autoHeight
    />
  );
};

export default OfferingOfferDetailsTable;

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
`;
